import axios from 'axios'
import { URIS, loadHeaders } from '../Uris'
import { notify } from 'react-notify-toast'

import { attributesConstants, pagesConstants, uiConstants } from '../constants'

export function loadAttributes (payload) {
  return dispatch => {
    dispatch((loading()))
    axios({
      method: 'GET',
      url: URIS.attributes + '?page=' + payload,
      headers: loadHeaders()
    }).then(res => {
      switch (payload) {
        // case pagesConstants.dashboard:
        //   dispatch(loadDashboardSuccess(res.data))
        //   break
        case pagesConstants.detections:
          dispatch(loadDetectionsSuccess(res.data))
          break
        default:
          dispatch(loadDashboardSuccess(res.data))
          break
      }
    }).catch(error => {
      if (error.response !== undefined) { dispatch(loadFailure(error.response.statusText)) } else { dispatch(loadFailure(error.message)) }
      notify.show('Errore caricamento profilo', uiConstants.toast.error, 3000)
    })
  }
}

function loading () {
  return {
    type: attributesConstants.LOAD_ATTRIBUTES
  }
}

function loadDashboardSuccess (payload) {
  return {
    type: attributesConstants.LOAD_ATTRIBUTES_DASHBOARD_SUCCESS,
    payload
  }
}

function loadDetectionsSuccess (payload) {
  return {
    type: attributesConstants.LOAD_ATTRIBUTES_DETECTIONS_SUCCESS,
    payload
  }
}

function loadFailure (payload) {
  return {
    type: attributesConstants.LOAD_ATTRIBUTES_FAILURE,
    payload
  }
}

// export function changeActiveRole (payload) {
//   return dispatch => {
//     dispatch((loading()))
//     axios({
//       method: 'POST',
//       url: URIS.attributes,
//       headers: loadHeaders(),
//       data: payload
//     }).then(res => {
//       dispatch(loadSuccess(res.data))
//     }).catch(error => {
//       if (error.response !== undefined) { dispatch(loadFailure(error.response.statusText)) } else { dispatch(loadFailure(error.message)) }
//     })
//   }
// }
